<style>
.img-fluid {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.carousel-inner {
  width: 100%;
  height: 100%;
}

.brand-logo {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  height: 160px;
  background-color: #fff !important;
  /* box-shadow: 0 0 18px 3px #000; */
}
</style>
<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <!-- <h2 class="brand-text text-primary ml-1">Vuexy</h2> -->
        <b-img
          :src="require('@/assets/images/logo/ngerplogo.png')"
          alt="logo"
          width="150px"
          height="135px"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        style="width: 100%; height: 100%"
        class="p-0 d-none d-lg-flex align-items-center"
      >
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center"
          style="width: 100%; height: 100%"
        >
          <b-carousel
            style="width: 100%; height: 100%"
            id=" carousel-interval"
            controls
            indicators
            :interval="3000"
          >
            <b-carousel-slide
              v-for="itemImage in banner"
              :key="itemImage.id"
              :img-src="itemImage"
              style="width: 100%; height: 100%"
            />
          </b-carousel>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Welcome to Nestoria Group! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account and start the adventure
          </b-card-text>

          <!-- <b-alert variant="primary" show>
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"
                  ><span class="font-weight-bold">Admin:</span> admin@demo.com |
                  admin</small
                >
              </p>
              <p>
                <small class="mr-50"
                  ><span class="font-weight-bold">Client:</span> client@demo.com
                  | client</small
                >
              </p>
            </div>
            <feather-icon
              v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10"
            />
          </b-alert> -->

          <!-- form -->
          <validation-observer ref="loginForm">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
<b-form-group label="Role" label-for="role">
                <validation-provider
                  #default="{ errors }"
                  name="role"
                  vid="role"
                  rules="required"
                >
                  <v-select
                    id="role"
                    v-model="role"
                    label="name"
                    :reduce="(option) => option.value"
                    :options="rolesOptions"
                    placeholder="Select role"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- Partner roles: OTP via WhatsApp -->
              <template v-if="isPartnerOtpLogin">
                <b-form-group
                  label="Email / Mobile Number / Partner ID"
                  label-for="login-identifier"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Identifier"
                    vid="identifier"
                    rules="required"
                  >
                    <b-form-input
                      id="login-identifier"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      :disabled="otpSent"
                      name="login-identifier"
                      placeholder="Email, mobile, or partner ID"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="otpSent"
                  label="Enter OTP"
                  label-for="login-otp"
                >
                  <div
                    class="otp-boxes"
                    :class="{ 'otp-boxes--invalid': !!otpFieldError }"
                  >
                    <input
                      v-for="(digit, index) in otpDigits"
                      :key="'otp-box-' + index"
                      :ref="'otpBox' + index"
                      :value="digit"
                      type="text"
                      inputmode="numeric"
                      maxlength="1"
                      autocomplete="one-time-code"
                      class="otp-box"
                      :class="{
                        'otp-box--filled': !!digit,
                        'otp-box--focused': activeOtpIndex === index,
                      }"
                      :aria-label="'OTP digit ' + (index + 1)"
                      @input="onOtpInput(index, $event)"
                      @keydown="onOtpKeydown(index, $event)"
                      @paste="onOtpPaste"
                      @focus="activeOtpIndex = index"
                      @blur="activeOtpIndex = null"
                    />
                  </div>
                  <small v-if="otpFieldError" class="text-danger">{{ otpFieldError }}</small>
                  <small v-if="maskedMobile" class="text-muted d-block mt-50">
                    OTP sent to WhatsApp number {{ maskedMobile }}
                  </small>
                  <div
                    v-if="otpSent"
                    class="d-flex flex-wrap justify-content-between align-items-center mt-50"
                  >
                    <small class="text-muted">
                      Didn't receive the code?
                    </small>
                    <b-link
                      :class="{ 'text-muted': !canResendOtp }"
                      :disabled="!canResendOtp"
                      @click.prevent="resendPartnerOtp"
                    >
                      <small>{{ resendOtpLabel }}</small>
                    </b-link>
                  </div>
                  <b-link
                    class="d-inline-block mt-50"
                    @click.prevent="resetOtpFlow"
                  >
                    <small>Use a different account</small>
                  </b-link>
                </b-form-group>
              </template>

              <!-- Employee, Admin: password login -->
              <template v-else>
                <b-form-group label="Username / Email" label-for="login-email">
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      name="login-email"
                      placeholder="john@example.com"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">Password</label>
                    <b-link :to="{ name: 'auth-forgot-password' }">
                      <small>Forgot Password?</small>
                    </b-link>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="Password"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </template>


              <!-- checkbox -->
              <b-form-group v-if="!isPartnerOtpLogin">
                <b-form-checkbox v-model="rememberMe" @change="handelCheckbox($event)">
                  Remember Me
                </b-form-checkbox>
              </b-form-group>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="otpLoading"
              >
                {{ submitButtonLabel }}
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{ name: 'auth-register' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">or</div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "axios";
import VueCookies from "vue-cookies";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BCarousel,
  BCarouselSlide,
  BButton,
  BAlert,
  BModal,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import vSelect from "vue-select";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { realtimeNotificationService } from "@/services/realtimeNotificationService";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BModal,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    BCarousel,
    BCarouselSlide,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rememberMe: false,
      visible: false,
      status: false,
      password: "",
      userEmail: "",
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      logo: require("@/assets/images/logo/ngerplogo.png"),

      // validation rules
      required,
      banner: [],
      baseApi: process.env.VUE_APP_APIENDPOINT,
      email,
      rolesOptions: [
        { name: "Employee", value: "employee" },
        { name: "Company Associate Partner", value: "companyassociatepartner" },
        { name: "Business Associate", value: "businessassociate" },
        { name: "Associate Partner", value: "associatepartner" },
        { name: "Admin", value: "admin" },
      ],
      role: "",
      otpDigits: ["", "", "", "", "", ""],
      otpFieldError: "",
      activeOtpIndex: null,
      otpSent: false,
      otpLoading: false,
      maskedMobile: "",
      otpResendCooldown: 0,
      otpResendTimerId: null,
    };
  },
  created() {
    const rememberedUsername = VueCookies.get("username");
    const rememberedPassword = VueCookies.get("password");

    if (rememberedUsername && rememberedPassword) {
      this.userEmail = rememberedUsername;
      this.password = rememberedPassword;
      this.rememberMe = true;
    }
  },
  watch: {
    role() {
      this.onRoleChange();
    },
  },
  mounted() {
    this.getBanner();
    // this.getRoles();
  },
  beforeDestroy() {
    this.stopOtpResendTimer();
  },
  computed: {
    isPartnerOtpLogin() {
      return (
        this.role === "companyassociatepartner" ||
        this.role === "businessassociate" ||
        this.role === "associatepartner"
      );
    },
    partnerOtpRole() {
      return this.role || "companyassociatepartner";
    },
    submitButtonLabel() {
      if (this.isPartnerOtpLogin) {
        return this.otpSent ? "Verify OTP & Sign in" : "Send OTP via WhatsApp";
      }
      return "Sign in";
    },
    canResendOtp() {
      return this.otpSent && !this.otpLoading && this.otpResendCooldown <= 0;
    },
    resendOtpLabel() {
      if (this.otpResendCooldown > 0) {
        return `Resend OTP in ${this.otpResendCooldown}s`;
      }
      return "Resend OTP";
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
    logoUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.logo = require("@/assets/images/logo/ngerplogo.png");
        return this.logo;
      }
      return this.logo;
    },
  },
  methods: {
    handelClickAgreement(value) {
      if (value == "decline") {
        this.visible = false;
        this.rememberMe = false;
        this.status = false;
      } else if (value == "accept") {
        this.visible = false;
        this.rememberMe = true;
        this.status = true;
      }
    },
    handelCheckbox(e) {
      this.visible = this.rememberMe;
      // this.rememberMe =false
    },
    async getBanner() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/auth/banners`,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((json) => {
          const data = json.data.data.data;
          data.map((item) => {
            if (item.position == "Login Page") {
              this.banner.push(item.image);
            }
          });
        })
        .catch((error) => console.log(error, "error"));
      if (JSON.stringify(this.banner) == "[]") {
        this.banner.push(this.imgUrl);
      }
    },
    async getRoles() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/auth/getPosition`,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((json) => {
          this.rolesOptions = json.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    onRoleChange() {
      this.password = "";
      this.clearOtpDigits();
      this.resetOtpFlow();
    },
    getOtpCode() {
      return this.otpDigits.join("");
    },
    clearOtpFieldError() {
      this.otpFieldError = "";
    },
    validateOtpField() {
      const code = this.getOtpCode();
      if (!/^\d{6}$/.test(code)) {
        this.otpFieldError = "Please enter the 6-digit OTP sent to your WhatsApp.";
        return false;
      }
      this.otpFieldError = "";
      return true;
    },
    clearOtpDigits() {
      this.otpDigits = ["", "", "", "", "", ""];
      this.otpFieldError = "";
      this.activeOtpIndex = null;
    },
    resetOtpFlow() {
      this.otpSent = false;
      this.clearOtpDigits();
      this.maskedMobile = "";
      this.otpLoading = false;
      this.otpResendCooldown = 0;
      this.stopOtpResendTimer();
    },
    startOtpResendCooldown(seconds = 60) {
      this.otpResendCooldown = seconds;
      this.stopOtpResendTimer();
      this.otpResendTimerId = setInterval(() => {
        if (this.otpResendCooldown <= 1) {
          this.otpResendCooldown = 0;
          this.stopOtpResendTimer();
        } else {
          this.otpResendCooldown -= 1;
        }
      }, 1000);
    },
    stopOtpResendTimer() {
      if (this.otpResendTimerId) {
        clearInterval(this.otpResendTimerId);
        this.otpResendTimerId = null;
      }
    },
    resendPartnerOtp() {
      if (!this.canResendOtp) {
        return;
      }
      this.requestPartnerOtp(true);
    },
    focusOtpBox(index) {
      const ref = this.$refs[`otpBox${index}`];
      const el = Array.isArray(ref) ? ref[0] : ref;
      if (el && typeof el.focus === "function") {
        el.focus();
        el.select();
      }
    },
    fillOtpFromString(str, startIndex = 0) {
      const chars = str.replace(/\D/g, "").split("");
      chars.forEach((ch, i) => {
        const idx = startIndex + i;
        if (idx < 6) {
          this.$set(this.otpDigits, idx, ch);
        }
      });
      const nextFocus = Math.min(startIndex + chars.length, 5);
      this.$nextTick(() => this.focusOtpBox(nextFocus));
    },
    onOtpInput(index, event) {
      const raw = event.target.value.replace(/\D/g, "");
      if (raw.length > 1) {
        this.fillOtpFromString(raw, index);
        this.clearOtpFieldError();
        return;
      }
      const digit = raw.slice(-1);
      this.$set(this.otpDigits, index, digit);
      event.target.value = digit;
      if (digit && index < 5) {
        this.$nextTick(() => this.focusOtpBox(index + 1));
      }
      if (this.getOtpCode().length === 6) {
        this.clearOtpFieldError();
      }
    },
    onOtpKeydown(index, event) {
      if (event.key === "Backspace") {
        if (this.otpDigits[index]) {
          this.$set(this.otpDigits, index, "");
          return;
        }
        if (index > 0) {
          event.preventDefault();
          this.$set(this.otpDigits, index - 1, "");
          this.$nextTick(() => this.focusOtpBox(index - 1));
        }
      }
      if (event.key === "ArrowLeft" && index > 0) {
        event.preventDefault();
        this.focusOtpBox(index - 1);
      }
      if (event.key === "ArrowRight" && index < 5) {
        event.preventDefault();
        this.focusOtpBox(index + 1);
      }
    },
    onOtpPaste(event) {
      event.preventDefault();
      const pasted = (event.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, 6);
      if (pasted) {
        this.fillOtpFromString(pasted, 0);
        if (this.getOtpCode().length === 6) {
          this.clearOtpFieldError();
        }
      }
    },
    showLoginError(message) {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title: "Login failed",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: message || "Unable to sign in. Please try again.",
        },
      });
    },
    completeLogin(response) {
      if (response.data.token) {
        let user = response.data.user;
        if (!user && response.data.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
          user = response.data.data[0];
        }

        useJwt.setToken(response.data.token);
        useJwt.setRefreshToken(response.data.token);

        localStorage.setItem("userData", JSON.stringify(user));

        if (user.originalUser) {
          localStorage.setItem("originalUserData", JSON.stringify(user.originalUser));
        } else if (response.data.originalUser) {
          localStorage.setItem("originalUserData", JSON.stringify(response.data.originalUser));
        } else if (user.original_user_name) {
          const originalUserData = {
            id: user.parent?.id || null,
            name: user.original_user_name,
            username: user.parent?.username || null,
            role: user.original_user_role,
            fullName: user.original_user_name,
          };
          localStorage.setItem("originalUserData", JSON.stringify(originalUserData));
        }

        this.$root.$emit("userDataUpdated");

        this.$ability.update([
          {
            action: "manage",
            subject: "all",
          },
        ]);
        this.$router.replace(getHomeRouteForLoggedInUser(user.role));
        if (this.rememberMe && !this.isPartnerOtpLogin) {
          VueCookies.set("username", this.userEmail, "30d");
          VueCookies.set("password", this.password, "30d");
        } else {
          VueCookies.remove("username");
          VueCookies.remove("password");
        }
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Welcome ${user.name || user.name}`,
            icon: "CoffeeIcon",
            variant: "success",
            text: `You have successfully logged in as ${user.role}. Now you can start to explore!`,
          },
        });
        realtimeNotificationService.requestPermission();
        location.reload();
      } else if (response.data.status == 404) {
        this.showLoginError(response.data.message);
      } else {
        this.showLoginError("Your account has been blocked. Please contact the admin.");
      }
    },
    async requestPartnerOtp(isResend = false) {
      this.otpLoading = true;
      try {
        const response = await axios({
          method: "POST",
          url: `${this.baseApi}/v1/login/request-otp`,
          headers: { "Content-Type": "application/json" },
          data: {
            username: this.userEmail,
            role: this.partnerOtpRole,
          },
        });
        if (response.data.status === 200 && response.data.data?.otp_sent) {
          this.otpSent = true;
          this.maskedMobile = response.data.data.masked_mobile || "";
          this.clearOtpDigits();
          this.startOtpResendCooldown(60);
          this.$nextTick(() => this.focusOtpBox(0));
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: isResend ? "OTP resent" : "OTP sent",
              icon: "MessageCircleIcon",
              variant: "success",
              text: response.data.message || "OTP sent to your registered WhatsApp number.",
            },
          });
        } else {
          this.showLoginError(response.data.message);
        }
      } catch (error) {
        const message = error.response?.data?.message || "Failed to send OTP. Please try again.";
        this.showLoginError(message);
      } finally {
        this.otpLoading = false;
      }
    },
    async verifyPartnerOtp() {
      this.otpLoading = true;
      try {
        const response = await axios({
          method: "POST",
          url: `${this.baseApi}/v1/login/verify-otp`,
          headers: { "Content-Type": "application/json" },
          data: {
            username: this.userEmail,
            otp: this.getOtpCode(),
            role: this.partnerOtpRole,
          },
        });
        this.completeLogin(response);
      } catch (error) {
        const message = error.response?.data?.message || "Invalid or expired OTP. Please try again.";
        this.showLoginError(message);
      } finally {
        this.otpLoading = false;
      }
    },
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (!success) {
          return;
        }

        if (this.isPartnerOtpLogin) {
          if (!this.otpSent) {
            this.requestPartnerOtp();
          } else if (this.validateOtpField()) {
            this.verifyPartnerOtp();
          }
          return;
        }

        useJwt
          .login({
            username: this.userEmail,
            password: this.password,
            role: this.role,
          })
          .then((response) => {
            this.completeLogin(response);
          })
          .catch((error) => {
            const message = error.response?.data?.message || "Please enter a valid username and password.";
            this.showLoginError(message);
          });
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.otp-boxes {
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  margin-bottom: 0.25rem;

  &--invalid .otp-box {
    border-color: #ea5455;
  }
}

.otp-box {
  width: 2.75rem;
  height: 3rem;
  padding: 0;
  text-align: center;
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 3rem;
  color: #5e5873;
  background-color: #fff;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    border-color: #7367f0;
    outline: none;
    box-shadow: 0 3px 10px 0 rgba(115, 103, 240, 0.15);
  }

  &--filled {
    border-color: #7367f0;
  }
}

.dark-layout .otp-box {
  color: #b4b7bd;
  background-color: #283046;
  border-color: #3b4253;

  &:focus,
  &.otp-box--filled {
    border-color: #7367f0;
  }
}
</style>
